var _path, _rect, _rect2, _rect3, _ellipse, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _ellipse2, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextConnectIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57732 18.0617C7.54675 17.2343 8.20923 16.5469 9.03719 16.5469L42.7321 16.5469L44.2679 16.5469C45.0747 16.5469 45.7287 17.2009 45.7287 18.0077V75.9279C45.7287 76.7347 45.0747 77.3888 44.2679 77.3888H42.7321H11.1768C10.3909 77.3888 9.74589 76.7671 9.71688 75.9818L7.57732 18.0617Z",
    fill: "#8D919B",
    stroke: "#8D919B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.52136,
    y: 16.5078,
    width: 35.2107,
    height: 60.8696,
    rx: 1.46087,
    fill: "white",
    stroke: "#8D919B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.52136,
    y: 68.6172,
    width: 35.2107,
    height: 0.380435,
    fill: "#8D919B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.52136,
    y: 21.8203,
    width: 35.2107,
    height: 0.380435,
    fill: "#8D919B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1267,
    cy: 73.2045,
    rx: 2.24749,
    ry: 2.28261,
    fill: "#8D919B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.518,
    y: 32.0938,
    width: 26.9699,
    height: 8.36956,
    rx: 0.730435,
    fill: "#28CAF4",
    stroke: "#8D919B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.518,
    y: 49.5938,
    width: 26.9699,
    height: 3.04348,
    rx: 0.730435,
    fill: "white",
    stroke: "#8D919B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.518,
    y: 55.6875,
    width: 22.4749,
    height: 3.04348,
    rx: 0.730435,
    fill: "#DBF3FB",
    stroke: "#8D919B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.518,
    y: 43.5,
    width: 15.3579,
    height: 3.04348,
    rx: 0.730435,
    fill: "#DBF3FB",
    stroke: "#8D919B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0063,
    y: 18.7734,
    width: 8.61538,
    height: 0.76087,
    rx: 0.380435,
    fill: "#8D919B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7692 18.1394C30.7692 9.83856 37.4984 3.10937 45.7993 3.10937L65.0644 3.10937C73.3131 3.10937 80 9.79625 80 18.0449C80 26.2364 73.4021 32.8994 65.211 32.9797L45.9468 33.1688C37.5886 33.2508 30.7692 26.498 30.7692 18.1394Z",
    fill: "white",
    stroke: "#8D919B",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.0769,
    cy: 18.2135,
    rx: 4.10256,
    ry: 4.16667,
    fill: "white",
    stroke: "#8D919B",
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.3846,
    cy: 18.2135,
    rx: 4.10256,
    ry: 4.16667,
    fill: "white",
    stroke: "#8D919B",
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.6923,
    cy: 18.2135,
    rx: 4.10256,
    ry: 4.16667,
    fill: "white",
    stroke: "#8D919B",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextConnectIllustration);
export default __webpack_public_path__ + "static/media/text-connect-illustration.0d4b3b35.svg";
export { ForwardRef as ReactComponent };